import { observer } from 'mobx-react-lite'
import { FormRow } from '@/components/Form'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { PasswordReset } from '@/features/iam/auth/PasswordReset'
import { type PasswordResetViewModel } from './PasswordResetViewModel'

export interface PasswordResetContainerProps {
  vm: PasswordResetViewModel
}

export const PasswordResetContainer = observer(function PasswordResetContainer({
  vm,
}: PasswordResetContainerProps) {
  return (
    <PasswordReset
      onSubmit={vm.submit}
      containsLowerCase={vm.containsLowerCase}
      containsUpperCase={vm.containsUpperCase}
      containsOneNumber={vm.containsOneNumber}
      containsSpecialCharacters={vm.containsSpecialCharacters}
      validMinimumLength={vm.validMinimumLength}
      validMaximumLength={vm.validMaximumLength}
      isValid={vm.valid}
      isResetPending={vm.resetPassword.pending}
      isResetRejected={vm.resetPassword.rejected}
      resetError={vm.resetPassword.error}
    >
      <FormRow>
        <TextInputContainer
          model={vm}
          field="email"
          name="email"
          label="Email"
          isDisabled
        />
      </FormRow>

      <FormRow>
        <TextInputContainer
          model={vm}
          field="password"
          name="password"
          label="Password"
          type="password"
        />
      </FormRow>
    </PasswordReset>
  )
})
